import axios from 'axios';
import {backendHost} from '../../../../store/config';

const getFreespin = (params) => {
    return axios.get(`${backendHost}/api/admin/freespin/check`, {params});
};

export {
    getFreespin
}